import IntlMessages from "@iso/components/utility/intlMessages";
import { Button, Form, Input } from "antd";
import React, { useEffect, useState } from "react";
import ReactPasswordChecklist from "react-password-checklist";
import { SidePanel } from "../../../components/SidePanel/SidePanel";
import { Navbar } from "../../../components/Navbar/Navbar";
import { useIntl } from "react-intl";
import { useNavigate, useSearchParams } from "react-router-dom";
import { createNotification } from "../../../components";
import ResetPasswordStyleWrapper from "./ResetPassword.styles";
import { useAuth } from "../../../contexts/auth";

function ResetPassword() {
  const { ResetPassword } = useAuth();
  const navigate = useNavigate();
  const intl = useIntl();

  const [searchParams] = useSearchParams();

  const code = searchParams.get("code");

  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [passwordConfirmation, setPasswordConfirmation] = useState({
    value: "",
  });

  const [isPasswordValid, setPasswordValid] = useState(false);

  useEffect(() => {
    if (!code) {
      navigate("/login", { replace: true });
    }
  }, [code]);

  const comparePasswords = (value) => {
    if (value === password) {
      return {
        validateStatus: "success",
        errorMsg: null,
      };
    }
    return {
      validateStatus: "error",
      errorMsg: "The passwords doesn't match!",
    };
  };

  const handlePasswordDiff = (value) => {
    setPasswordConfirmation({ ...comparePasswords(value), value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);

    return await ResetPassword(password, code)
      .then(() => {
        createNotification(
          "success",
          intl.formatMessage({
            id: "page.resetPassword.notification.success.title",
          }),
          intl.formatMessage({
            id: "page.resetPassword.notification.success.description",
          }),
        );
        navigate("/", { replace: true });
      })
      .catch((err) => {
        if (err.response.data) {
          createNotification("error", "Error", err.response.data.message);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const showPasswordList = () => {
    if (password !== passwordConfirmation.value) {
      return true;
    }
    if (!password) {
      return false;
    }
    return !!(password && !isPasswordValid);
  };

  return (
    <>
      <Navbar />
      <ResetPasswordStyleWrapper className="isoSignUpPage">
        <div className="isoSignUpContentWrapper">
          <div className="isoSignUpContent">
            <h3 className="text-xl">
              <IntlMessages id="page.resetPasswordButton" />
            </h3>
            <Form onSubmit={handleSubmit} layout="vertical">
              <Form.Item
                label={intl.formatMessage({ id: "newPassword" })}
                rules={[
                  { required: true, message: "Please type your password!" },
                ]}
              >
                <Input
                  success={isPasswordValid.toString()}
                  type="password"
                  placeholder="********"
                  onChange={(e) => setPassword(e.target.value)}
                  size="large"
                />
              </Form.Item>
              {showPasswordList() && (
                <ReactPasswordChecklist
                  rules={[
                    "minLength",
                    "specialChar",
                    "number",
                    "capital",
                    "lowercase",
                    "match",
                  ]}
                  messages={{
                    minLength: "At least 8 characters",
                    specialChar: "Contains a symbol",
                    number: "Contains a number",
                    capital: "At least 1 uppercase letter",
                    lowercase: "At least 1 lowercase letter",
                  }}
                  minLength={8}
                  value={password}
                  valueAgain={passwordConfirmation.value}
                  onChange={(isValid) => {
                    setPasswordValid(isValid);
                  }}
                  iconSize={10}
                  invalidColor="#E16408"
                  validColor="#00ABAB"
                />
              )}
              <Form.Item
                label={intl.formatMessage({ id: "confirmPassword" })}
                validateStatus={passwordConfirmation.validateStatus}
                help={passwordConfirmation.errorMsg}
                rules={[
                  {
                    required: true,
                    message: "Please confirm your password!",
                  },
                ]}
              >
                <Input
                  success={isPasswordValid.toString()}
                  type="password"
                  placeholder="********"
                  value={passwordConfirmation.value}
                  onChange={(e) => handlePasswordDiff(e.target.value)}
                  size="large"
                />
              </Form.Item>
              <div className="flex justify-end">
                <Button
                  className="bg-primary border-0 text-white !px-12 shadow-none"
                  size="large"
                  htmlType="submit"
                  shape="round"
                  onClick={handleSubmit}
                  loading={loading}
                  disabled={!isPasswordValid}
                  type="primary"
                >
                  <IntlMessages id="page.forgotPasswordCTA" />
                </Button>
              </div>
            </Form>
          </div>
        </div>
        <SidePanel />
      </ResetPasswordStyleWrapper>
    </>
  );
}

export default ResetPassword;
